import { toast } from "react-toastify";
import { staticMessagesError } from "../helpers/staticMessagesError";
import { postBlock } from "../service/postBlock";
import convertAmountInCents from "../utils/amountInCents";
import { TIME_RESULT } from "../utils/notifications/time";
import { toastUpdate } from "../utils/notifications/toast";
import { IProduct } from "../views/ecommerce/products/interfaces";
import { errorHandlerApi } from "./errorHandlerApi";

export const addDetail = async (
    values: {
        details: string,
        amount: string,
    }, 
    selectedProduct: IProduct
): Promise<{
    isError: boolean,
    block: any,
}> => {
    let amount = convertAmountInCents(values.amount).toString()
    
    const { isError, block } = await postBlock("/branch/products/details", {
        details: values.details,
        active: true,
        amount: amount,
        productId: selectedProduct.id
    });

    if(isError) {
        errorHandlerApi(block,  staticMessagesError.ADD_DETAIL, ()=> {}, "createDetail")
    }

    else {
        toastUpdate(
            "createDetail",
            "success",
            TIME_RESULT,
            "Variação do produto criada com sucesso!"
        )
    }

    return {
        isError: isError,
        block: block
    }
}